'use client';

/* eslint-disable react-hooks/exhaustive-deps */
import { useForm } from 'react-hook-form';
import React, { useState, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';

import {
  Box,
  Table,
  Avatar,
  Button,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  IconButton,
  Typography,
  TableContainer,
} from '@mui/material';

// import { bookingSchema } from 'src/utils/validations';
import PaymentDrawer from 'src/utils/common/PaymentDrawer';
import { decryptData, encryptData } from 'src/utils/encrypt';
import { fCurrency, fCurrencyWithoutCode } from 'src/utils/format-number';
import UpdateContactDetailsModal from 'src/utils/common/order-details-update-contact-modal';
import {
  USERE_DETAILS,
  USER_MOBILE_NUMBER,
  USER_ID_STORAGE_KEY,
  JWT_STORAGE_KEY,
} from 'src/utils/constants';
import {
  notify,
  getLongLat,
  getLoadType,
  getTruckType,
  getCountryKey,
  getCityDetails,
  getRouteSummary,
  transformDateSlot,
  getLocationDetails,
  getNameForLanguage,
  getLabelForlanguage,
  visibleViewsInPaymentModal,
} from 'src/utils/helper';

import { queryClient } from 'src/lib/api';
import { useLocale, useTranslate } from 'src/locales';
import { useOTP, useLogin } from 'src/api/useLogin';
import { useInitSTCPay_Order } from 'src/api/payment/stc';
import { useGetWalletBalance } from 'src/api/payment/wallet';
import { getLocationByCord } from 'src/api/location/location';
import { useUserRegister, useCompanyRegister } from 'src/api/useRegister';
import { useGetAllFleets, useGetSlotsForTruck } from 'src/api/Order/useFleet';
import { useCarcPaymentPoller } from 'src/api/payment/useCardPaymentCookiePoller';
import { usePlaceOrder, useGetPriceOfOrder, useDeleteSavedLocation } from 'src/api/Order/useOrder';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import Counter from './Counter';
import { Login } from './login/login';
import CustomDrawer from './CustomDrawer';
import { LoginOTP } from './login/login-otp';
import { RegisterView } from './login/view/register-view';
import { GoogleAddressPasteModal } from './modal/google-address-paste-modal';
import RouteMap from './DirectionComp';
import { createSchemas } from 'src/utils/use-validations';
import { useChangeLanguagePref } from 'src/api/useProfile';
import { set } from 'nprogress';

export function BookNow({
  setMapsData,
  mapsData,
  markersData,
  setMarkersData,
  directionsData,
  refreshMap,
  editPermission,
  isDragged,
  setIsDragged,
  defaultLocation,
  setDirectionsData,
  styles,
  Map,
  handleDrag,
  getCurrentLocation,
  setShowBookNowForm,
  currentLocation,
}) {
  // const { user } = useAuthContext();
  const { onChangeLang, currentLang, updateLangOnServer } = useTranslate();
  const { t } = useLocale();
  const user = decryptData(sessionStorage?.getItem(USERE_DETAILS));
  const userID = sessionStorage?.getItem(USER_ID_STORAGE_KEY);
  const token =
    sessionStorage?.getItem(JWT_STORAGE_KEY) || localStorage?.getItem(JWT_STORAGE_KEY) || '';
  const language = localStorage.getItem('i18nextLng') || 'ar';
  const isRTL = language === 'ar';
  const theme = localStorage.getItem('theme-mode') || 'dark';
  const { bookingSchema } = createSchemas();

  const { data: fleets } = useGetAllFleets();
  const {
    data: invoice,
    mutateAsync: getPriceOfOrder,
    isPending: isPriceOfOrderLoading,
  } = useGetPriceOfOrder();

  const { data: initStcDetails, mutateAsync: initStcPayForOrder } = useInitSTCPay_Order();
  const { mutateAsync: placeOrder, isPending: isOrderLoading } = usePlaceOrder();
  const { mutateAsync: getWalletBalance } = useGetWalletBalance();
  const { data: loginData, mutateAsync: login, isPending: isLoginLoading } = useLogin();
  const { data: otpData, mutateAsync: validateOTP, isPending: isValidateOTPLoading } = useOTP();
  const {
    data: userRegisterData,
    mutateAsync: registerUser,
    isPending: isUserRegisterLoading,
  } = useUserRegister();
  const {
    data: companyRegisterData,
    mutateAsync: registerCompany,
    isPending: isCompanyRegisterLoading,
  } = useCompanyRegister();
  const { mutateAsync: deleteSavedLocation } = useDeleteSavedLocation();
  const { mutate: changeLanguage } = useChangeLanguagePref();

  const [formDetails, setFormDetails] = useState(null);
  const [isInvoiceDetailsVisible, setIsInvoiceDetailsVisible] = useState(false);
  const [isPaymentDrawerVisible, setIsPaymentDrawerVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(null);
  const [orderSuccessDetails, setOrderSuccessDetails] = useState('');
  const [isUpdateContactDetailsModalVisible, setIsUpdateContactDetailsModalVisible] =
    useState(false);

  const [isSaveLocationModalVisible, setIsSaveLocationModalVisible] = useState(false);
  const [saveLocationDetails, setSaveLocationDetails] = useState(null);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [googleMapsLinkData, setGoogleMapsLinkData] = useState({
    modal: false,
    locationType: '',
    locationName: '',
  });
  const [isAddressPasted, setIsAddressPasted] = useState(false);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const [isLoginOTPModalVisible, setIsLoginOTPModalVisible] = useState(false);
  const [isRegisterModalVisible, setIsRegisterModalVisible] = useState(false);

  // To watch if Card Payment is successfull or not
  const { startPolling: startCardPaymentPolling, stopPolling: stopCardPaymentPolling } =
    useCarcPaymentPoller({
      onSuccess: (res) => {
        console.log('✅ Order Paid in Order Drawer book now:', res);

        setVisibleView(null);
        stopCardPaymentPolling();
        setIsUpdateContactDetailsModalVisible(true);
        onOrderSuccess(res?.data?.success, 'card');
      },
      onError: (res) => {
        console.log('❌ Payment Failed in Drawer:', res);
        onPaymentError(res?.data);
        stopCardPaymentPolling();
      },
      onReset: () => {
        // setVisibleView('');
      },
    });

  // ------------------------------------------------------------------------------------------------------------------------------------
  const defaultValues = {
    pickupLocation_search: '',
    deliveryLocation_1_search: '',
    deliveryLocation_2_search: null,
    truckSize: '',
    trucktype: '',
    quantity: 1,
    timeAndSlot: '',
    isSecondDropLocationVisible: false,
    goodsValue: '',
    loadType: '',
    loadQauntity: null,
    loadTypeText: '',
  };

  const isDisableForm = isPriceOfOrderLoading || isOrderLoading;
  const methods = useForm({
    resolver: zodResolver(bookingSchema),
    defaultValues,
    mode: 'all',
    disabled: isDisableForm,
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    clearErrors,

    // formState: { isSubmitting, isValid },
  } = methods;

  // Get Price Of Order
  const onSubmit = handleSubmit(async (formValues) => {
    try {
      if (!directionsData) {
        notify('error', 'No route found');
        return;
      }

      let listOfCities = [
        {
          regions: getCityDetails(formValues.pickupLocation_search?.address_components),
        },
        {
          regions: getCityDetails(formValues.deliveryLocation_1_search?.address_components),
        },
      ];
      let targetLocation = [getLocationDetails(formValues.deliveryLocation_1_search, user)];
      let listOfCountries = [
        getCountryKey(formValues.pickupLocation_search?.address_components),
        getCountryKey(formValues.deliveryLocation_1_search?.address_components),
      ];

      if (formValues.deliveryLocation_2_search?.address_components) {
        listOfCities.push({
          regions: getCityDetails(formValues.deliveryLocation_2_search?.address_components),
        });
        targetLocation.push(getLocationDetails(formValues.deliveryLocation_2_search, user));
        listOfCountries.push(
          getCountryKey(formValues.deliveryLocation_2_search?.address_components)
        );
      }

      const payload = {
        listOfCities,
        targetLocation,
        listOfCountries,
        // userID,
        truckSize: formValues.truckSize?.name,
        truckType: formValues.trucktype?.name,
        trucksCount: formValues.quantity,
        paymentMode: ['wallet'],
        typeOfLoad: formValues.loadType.nameen,
        packetPrice: 0,
        pickupLocation: [getLocationDetails(formValues.pickupLocation_search, user)],
        valueOfGoods: formValues.goodsValue || '0',
        loadQuanitity: formValues.loadQauntity || '0',
        token: user?.token,
        fromWhichApplication: 'ShahenWebsite',
        exactLoadType: formValues.loadTypeText,
        distance: getRouteSummary(directionsData?.legs)?.totalDistanceKm,
        listOfMinutes: getRouteSummary(directionsData?.legs)?.durationsInMinutes,
      };
      setFormDetails(formValues);
      getPriceOfOrder(payload, {
        onSuccess: (res) => {
          if (res.error) {
            notify('error', res?.error || 'Something went wrong');
            return;
          }
          if (res?.price) {
            setIsInvoiceDetailsVisible(true);
          }
          if (!res?.price) {
            notify('error', t('pickupAndDropLocationCannotBeSame'));
          }
        },
      });
    } catch (error) {
      console.log('Error in get price : ', error);
    }
  });

  // --------------------------------------------------------------- Login, OTP and Register Data Management ---------------------------------------------------------------------

  // Login Data Management either success or error
  useEffect(() => {
    if (loginData) {
      if (Object.keys(loginData?.success || {}).length > 0) {
        setIsLoginModalVisible(!isLoginModalVisible);
        setIsLoginOTPModalVisible(!isLoginOTPModalVisible);
        sessionStorage.setItem(USER_MOBILE_NUMBER, loginData?.success?.mobileNumber);
        sessionStorage.setItem(USER_ID_STORAGE_KEY, loginData?.success?.userID);
      }
      if (loginData?.error) {
        notify('error', loginData?.error || 'Something went wrong');
      }
    }
  }, [loginData]);

  // OTP Data Management either success or error
  useEffect(() => {
    if (otpData) {
      if (Object.keys(otpData?.success || {}).length > 0) {
        setIsLoginOTPModalVisible(!isLoginOTPModalVisible);
        if (otpData?.success?.userStatus?.toLocaleLowerCase() === 'unregistered') {
          setIsRegisterModalVisible(!isRegisterModalVisible);
        }
        if (otpData?.success?.userStatus?.toLocaleLowerCase() === 'active') {
          const token = otpData?.success?.userDetails?.[0]?.token || '';
          changeLanguage({
            userID: otpData?.success?.userDetails?.[0]?.userID,
            defaultLang: language,
            token,
          });
          sessionStorage.setItem(
            USERE_DETAILS,
            encryptData(otpData?.success?.userDetails?.[0]) || ''
          );
          sessionStorage.setItem(JWT_STORAGE_KEY, token || '');
          setTimeout(() => {
            setIsPaymentDrawerVisible(!isPaymentDrawerVisible);
          }, 200);
        }
      }
      if (otpData?.error) {
        notify('error', otpData?.error || 'Something went wrong');
      }
    }
  }, [otpData]);

  // Company Register Data Management either success or error

  useEffect(() => {
    if (companyRegisterData) {
      if (Object.keys(companyRegisterData?.success || {})?.length > 0) {
        const token = sessionStorage.getItem(JWT_STORAGE_KEY) || '';
        setIsRegisterModalVisible(!isRegisterModalVisible);
        changeLanguage({
          userID: companyRegisterData?.success?.userID,
          defaultLang: language,
          token,
        });
        sessionStorage.setItem(USER_ID_STORAGE_KEY, companyRegisterData?.success?.userID);
        sessionStorage.setItem(
          USERE_DETAILS,
          encryptData(companyRegisterData?.success?.addCompanyDetails) || {}
        );
        setIsPaymentDrawerVisible(!isPaymentDrawerVisible);
      }
      if (companyRegisterData?.error) {
        notify('error', companyRegisterData?.error || 'Something went wrong');
      }
    }
  }, [companyRegisterData]);

  // User Register Data Management either success or error
  useEffect(() => {
    if (userRegisterData) {
      if (userRegisterData?.success) {
        setIsRegisterModalVisible(!isRegisterModalVisible);
        setIsPaymentDrawerVisible(!isPaymentDrawerVisible);
      }
      if (userRegisterData?.error) {
        console.log('userRegisterData?.error', userRegisterData?.error);
        notify('error', userRegisterData?.error || 'Something went wrong');
      }
    }
  }, [userRegisterData]);

  // ------------------------------------------------------------------------------------------------------------------------------------

  const { data: slots } = useGetSlotsForTruck(watch('truckSize')?.name, watch('trucktype')?.name);

  useEffect(() => {
    if (currentLocation && currentLocation?.lat && currentLocation?.lng) {
      getLocation(`${currentLocation?.lat},${currentLocation?.lng}`, 'pickupLocation_search');
      setMarkersData((prevState) => ({
        ...prevState,
        pickupLocationDetails: currentLocation || null,
      }));
      setMapsData((prevState) => ({
        ...prevState,
        pickupLocationDetails: currentLocation || null,
      }));
      setLat(currentLocation?.lat);
      setLng(currentLocation?.lng);
    }
  }, [currentLocation]);

  // useEffect(() => {
  //   if (markersData?.pickupLocationDetails) {
  //     getLocation(
  //       `${markersData?.pickupLocationDetails?.lat},${markersData?.pickupLocationDetails?.lng}`,
  //       'pickupLocation_search'
  //     );
  //     setLat(mapsData?.pickupLocationDetails?.lat);
  //     setLng(mapsData?.pickupLocationDetails?.lng);
  //   }
  // }, [markersData?.pickupLocationDetails]);

  // useEffect(() => {
  //   if (markersData?.delivery_1_LocationDetails) {
  //     getLocation(
  //       `${markersData?.delivery_1_LocationDetails?.lat},${markersData?.delivery_1_LocationDetails?.lng}`,
  //       'deliveryLocation_1_search'
  //     );
  //     setLat(mapsData?.delivery_1_LocationDetails?.lat);
  //     setLng(mapsData?.delivery_1_LocationDetails?.lng);
  //   }
  // }, [markersData?.delivery_1_LocationDetails]);

  // useEffect(() => {
  //   if (markersData?.delivery_2_LocationDetails) {
  //     getLocation(
  //       `${markersData?.delivery_2_LocationDetails?.lat},${markersData?.delivery_2_LocationDetails?.lng}`,
  //       'deliveryLocation_2_search'
  //     );
  //     setLat(mapsData?.delivery_2_LocationDetails?.lat);
  //     setLng(mapsData?.delivery_2_LocationDetails?.lng);
  //   }
  // }, [markersData?.delivery_2_LocationDetails]);

  useEffect(() => {
    if (isDragged) {
      if (mapsData?.pickupLocationDetails?.formatted_address) {
        setValue('pickupLocation_search', mapsData?.pickupLocationDetails);
      }
      if (mapsData?.delivery_1_LocationDetails?.formatted_address) {
        setValue('deliveryLocation_1_search', mapsData?.delivery_1_LocationDetails);
      }
      if (mapsData?.delivery_2_LocationDetails?.formatted_address) {
        setValue('deliveryLocation_2_search', mapsData?.delivery_2_LocationDetails);
      }
    }
    setIsDragged(false);
  }, [isDragged, mapsData]);

  const getLocation = async (cords, type) => {
    const res = await getLocationByCord(cords);
    setValue(type, res?.predictions?.[0]);
  };

  const handleToggleSecondLocation = () => {
    if (watch('isSecondDropLocationVisible')) {
      setValue('deliveryLocation_2_search', null);
      updateMapsData('delivery_2_LocationDetails', '');
    }
    setValue('isSecondDropLocationVisible', !watch('isSecondDropLocationVisible'));
  };

  const updateMapsData = (key, value) => {
    setMapsData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    // setMarkersData((prevState) => ({
    //   ...prevState,
    //   [key]: value,
    // }));
    setLat(value?.lat);
    setLng(value?.lng);
  };

  const handleInvoiceDetailsClose = () => {
    setIsInvoiceDetailsVisible(false);
  };

  const handleCloseGoogleAddressPasteModal = () => {
    setGoogleMapsLinkData((prevState) => ({
      ...prevState,
      modal: false,
    }));
  };

  const togglePaymentDrawer = () => {
    setIsInvoiceDetailsVisible(false);
    setVisibleView(null);
    setIsLoginModalVisible(!isLoginModalVisible);
  };

  const closePaymentDrawer = () => {
    setIsInvoiceDetailsVisible(false);
    setVisibleView(null);
    setIsPaymentDrawerVisible(!isPaymentDrawerVisible);
  };

  const onPaymentError = (err) => {
    notify('error', err?.error || 'Something went wrong');
  };

  const onOrderSuccess = async (res, paymentMode) => {
    // togglePaymentDrawer();
    closePaymentDrawer?.();
    setFormDetails(null);
    getWalletBalance();
    await refreshMap?.();
    reset();
    // if (paymentMode !== 'paymentMode') {
    notify('success', res?.toString() || 'Success');
    // }
  };

  const onStcInitSuccess = (res) => {
    if (res?.success) {
      setVisibleView(visibleViewsInPaymentModal?.verifyStc);
      notify('success', 'OTP Sent to Your registered Number');
    } else {
      notify('error', res?.error || 'Something went wrong');
    }
  };

  const onPad = (isWallet) => {
    handlePlaceOrder('PayAfterDelivery', isWallet);
  };

  const onCardPayment = (cardDetails, cvv, isWallet) => {
    handlePlaceOrder('card', isWallet, { cvv, ...cardDetails });
  };

  const onWalletPayment = () => {
    handlePlaceOrder('wallet', true);
  };

  const onStcVerify = (stc, isWallet, walletBalance) => {
    handlePlaceOrder('stcpay', isWallet, stc, walletBalance);
  };

  const onStcInit = (STCMobileNumber, isWallet, walletBalance) => {
    const payload = {
      userID,
      mobileNumber: STCMobileNumber,
      price: invoice?.totalPrice,
      wallet: isWallet ? 'yes' : 'no',
    };
    initStcPayForOrder(payload, {
      onSuccess: onStcInitSuccess,
      onError: onPaymentError,
    });
  };

  const onCreditPayment = () => {
    handlePlaceOrder('credit');
  };

  const handlePlaceOrder = (paymentMode, isWallet, paymentDetails, walletBalance) => {
    // -----------------------------------------------------------//

    let pickupLocationObj = getLocationDetails(formDetails?.pickupLocation_search, user);
    let deliveryLocation1Obj = getLocationDetails(formDetails?.deliveryLocation_1_search, user);
    let deliveryLocation2Obj = getLocationDetails(formDetails?.deliveryLocation_2_search, user);

    let listOfCities = [
      {
        regions: getCityDetails(formDetails?.pickupLocation_search?.address_components),
      },
      {
        regions: getCityDetails(formDetails?.deliveryLocation_1_search?.address_components),
      },
    ];
    let targetLocation = [
      {
        ...deliveryLocation1Obj,
        lat: mapsData?.delivery_1_LocationDetails?.lat,
        long: mapsData?.delivery_1_LocationDetails?.lng,
      },
    ];
    let listOfCountries = [
      getCountryKey(formDetails?.pickupLocation_search?.address_components),
      getCountryKey(formDetails.deliveryLocation_1_search?.address_components),
    ];

    let locationDetails = {
      pickupPoints: {
        type: 'Point',
        coordinates: getLongLat(formDetails?.pickupLocation_search),
      },
      deliveryPoints1: {
        type: 'Point',
        coordinates: getLongLat(formDetails?.deliveryLocation_1_search),
      },
    };

    if (formDetails?.deliveryLocation_2_search?.address_components) {
      listOfCities.push({
        regions: getCityDetails(formDetails?.deliveryLocation_2_search?.address_components),
      });
      targetLocation.push({
        ...deliveryLocation2Obj,
        lat: mapsData?.delivery_2_LocationDetails?.lat,
        long: mapsData?.delivery_2_LocationDetails?.lng,
      });
      listOfCountries.push(
        getCountryKey(formDetails?.deliveryLocation_2_search?.address_components)
      );
      locationDetails.deliveryPoints2 = {
        type: 'Point',
        coordinates: getLongLat(formDetails?.deliveryLocation_2_search),
      };
    }

    // -----------------------------------------------------------//
    const payload = {
      ...locationDetails,
      targetLocation,
      listOfCities,
      userID,
      pickupDate: transformDateSlot(formDetails?.timeAndSlot),
      pickupLocation: [
        {
          ...pickupLocationObj,
          lat: mapsData?.pickupLocationDetails?.lat,
          long: mapsData?.pickupLocationDetails?.lng,
        },
      ],
      lat: getLongLat(formDetails.pickupLocation_search)[1],
      long: getLongLat(formDetails.pickupLocation_search)[0],
      paymentMode: [paymentMode],
      distance: getRouteSummary(directionsData?.legs)?.totalDistanceKm,
      listOfMinutes: getRouteSummary(directionsData?.legs)?.durationsInMinutes,
      truckType: formDetails.trucktype?.name,
      truckSizeInQty: formDetails?.trucktype?.size,
      maxLoad: formDetails?.trucktype?.maximumLoad,
      logo: formDetails?.trucktype?.imagePaths.logo,
      truckSize: formDetails.truckSize?.name,
      trucksCount: formDetails.quantity,
      typeOfLoad: formDetails.loadType.nameen,
      price: invoice?.totalPrice,
      priceToken: invoice?.priceToken,
      truckSizeID: formDetails?.trucktype?.truckSizeId,
      invoiceDetails: invoice,
      valueOfGoods: formDetails?.goodsValue || '0',
      insuranceAmount: invoice?.insuranceAmount || '0',
      version: 'V2',
      source: 'browser',
      orderPlacedBy: 'ShahenWebsite',
      loadQuanitity: formDetails.loadQauntity || '0',
    };
    payload.invoiceDetails.paymentMode = [paymentMode];

    if (isWallet && paymentMode !== 'wallet') {
      payload?.invoiceDetails?.paymentMode?.push('wallet');
      payload?.paymentMode?.push('wallet');
    }

    if (formDetails?.loadType?.nameen?.toLocaleLowerCase()?.includes('other')) {
      payload.exactLoadType = formDetails.loadTypeText;
    }
    if (paymentMode == 'stcpay') {
      payload.stcPayDetails = {
        wallet: Number(initStcDetails?.success?.wallet),
        amount: Number(initStcDetails?.success.amount),
        mobileNumber: paymentDetails?.number,
        otp: paymentDetails?.otp,
        stcPayPmtReference: initStcDetails?.success.stcPayPmtReference,
        otpReference: initStcDetails?.success?.otpReference,
      };
    }
    if (paymentMode === 'card') {
      startCardPaymentPolling();
      payload.cvv = paymentDetails?.cvv;
      payload.invoiceDetails.paymentMode = [paymentDetails?.cardNumber];
      payload.paymentMode = [paymentDetails?.cardNumber];

      if (isWallet) {
        payload?.invoiceDetails?.paymentMode?.push('wallet');
        payload?.paymentMode?.push('wallet');
      }
    }
    placeOrder(payload, {
      onSuccess: (res) => {
        if (res?.success) {
          setOrderSuccessDetails(res);
          if (res?.redirectLink) {
            window.open(res?.redirectLink, '_blank');
            return;
          }
          setIsUpdateContactDetailsModalVisible(true);
          onOrderSuccess(res?.success, paymentMode);
        } else {
          notify('error', res?.error?.toString() || 'Somthing went wrong');
        }
      },
    });
  };

  const handleCloseContactDetailsModal = () => {
    setIsUpdateContactDetailsModalVisible(false);
  };

  const rows = [
    {
      description: `${watch().truckSize?.[getLabelForlanguage('name')]} (${watch('trucktype')?.[getLabelForlanguage('name')]})`,
      price: invoice?.userPrice / invoice?.trucksCount,
      qty: invoice?.trucksCount,
      subtotal: invoice?.userPrice,
      visible: true,
    },
    {
      description: t('Discount'),
      price: '',
      qty: '',
      subtotal: -invoice?.discount,
      visible: !!invoice?.discount,
    },
    {
      description: t('Insurance'),
      price: '',
      qty: '',
      subtotal: invoice?.insuranceAmount || '0',
      visible: invoice?.insuranceAmount !== 0,
    },
    {
      description: `${t('VAT')} (${invoice?.vat || 0}%)`,
      price: '',
      qty: '',
      subtotal: invoice?.calculatedVatAmount || '0',
      visible: true,
    },
  ];

  const handleCloseSaveLocationModal = () => {
    setIsSaveLocationModalVisible(false);
  };

  const handleOnSaveLocation = (place, type) => {
    if (!place) return;
    const payload = {
      userID,
      ...getLocationDetails(place),
      lat: place?.lat || Number(place?.geometry?.location?.lat) || 0,
      long: place?.lng || Number(place?.geometry?.location?.lng) || 0,
      type,
      name: '',
    };
    setSaveLocationDetails(payload);
    setIsSaveLocationModalVisible(true);
  };

  const handleDeleteSavedLocation = (location) => {
    deleteSavedLocation(
      {
        userID,
        favoriteLocationID: location?.favoriteLocationID,
      },
      {
        onSuccess: (res) => {
          if (res?.success) {
            queryClient.fetchQuery({ queryKey: ['useGetSavedLocation', location?.type] });
            notify('success', res?.success?.toString());
          }

          if (res.error) {
            notify('error', res?.error?.toString());
          }
        },
      }
    );
  };

  // Function for select Place from AutoComplete
  const selectPlace = (place, type, name) => {
    updateMapsData(type, place?.geometry?.location);
    setValue(name, place);
  };

  // Reset Places auto complete errors
  useEffect(() => {
    if (watch('pickupLocation_search')) {
      clearErrors('pickupLocation_search', { keepError: false });
    }
    if (watch('deliveryLocation_1_search')) {
      clearErrors('deliveryLocation_1_search', { keepError: false });
    }
    if (watch('deliveryLocation_2_search')) {
      clearErrors('deliveryLocation_2_search', { keepError: false });
    }
  }, [
    watch('pickupLocation_search'),
    watch('deliveryLocation_1_search'),
    watch('deliveryLocation_2_search'),
    clearErrors,
  ]);

  const handleLoginBack = () => {
    setIsLoginModalVisible(!isLoginModalVisible);
    setIsInvoiceDetailsVisible(!isInvoiceDetailsVisible);
  };

  const handleLoginOTPBack = () => {
    setIsLoginOTPModalVisible(!isLoginOTPModalVisible);
    setIsLoginModalVisible(!isLoginModalVisible);
  };
  const handleRegisterBack = () => {
    setIsRegisterModalVisible(!isRegisterModalVisible);
    setIsLoginModalVisible(!isLoginModalVisible);
  };

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: theme === 'dark' ? '#00000014' : '#ffffffe3',
        borderRadius: 2,
        width: '100%',
      }}
    >
      <Form methods={methods} onSubmit={onSubmit}>
        <Box flexDirection="column" display="flex" gap={2}>
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: 'column', lg: 'row' },
              flexWrap: 'wrap',
              gap: 1,
              flex: 1,
            }}
          >
            <Box display="flex" flexDirection="column" gap={1} flex={1}>
              <Field.PlacesAutoComplete
                name="pickupLocation_search"
                type="pickupLocationDetails"
                label={t('Pickup_location')}
                placeholder={t('Enter_Pickup_location')}
                onPlaceSelect={(place, type, name) => {
                  selectPlace(place, type, name);
                }}
                onSavedLocationDelete={handleDeleteSavedLocation}
                setGoogleMapsLinkData={setGoogleMapsLinkData}
                setIsAddressPasted={setIsAddressPasted}
                isAddressPasted={isAddressPasted}
                isDisableForm={isDisableForm}
              />
            </Box>
            <Box display="flex" flexDirection="column" gap={1} flex={1}>
              <Box display="flex" flexDirection="row" gap={1} alignItems="center">
                <Field.PlacesAutoComplete
                  name="deliveryLocation_1_search"
                  type="delivery_1_LocationDetails"
                  label={t('Delivery_Stop_1')}
                  placeholder={t('Enter_Drop_location') + ' 1'}
                  leftIconName="line-md:map-marker-radius-filled"
                  leftIconColor="primary.main"
                  onPlaceSelect={(place, type, name) => {
                    selectPlace(place, type, name);
                  }}
                  onSaveLocation={(place) => handleOnSaveLocation(place, 'delivery')}
                  onSavedLocationDelete={handleDeleteSavedLocation}
                  setGoogleMapsLinkData={setGoogleMapsLinkData}
                  setIsAddressPasted={setIsAddressPasted}
                  isAddressPasted={isAddressPasted}
                  isDisableForm={isDisableForm}
                />

                {!watch('isSecondDropLocationVisible') && (
                  <IconButton
                    onClick={handleToggleSecondLocation}
                    disabled={isDisableForm}
                    aria-label="add second delivery location"
                  >
                    <Iconify
                      icon="line-md:plus-circle-filled"
                      sx={{ color: !isDisableForm && 'primary.main' }}
                    />
                  </IconButton>
                )}
              </Box>
            </Box>
            {watch('isSecondDropLocationVisible') && (
              <Box flexDirection="column" display="flex" gap={1} flex={1}>
                <Box display="flex" flexDirection="row" gap={1} alignItems="center">
                  <Field.PlacesAutoComplete
                    name="deliveryLocation_2_search"
                    type="delivery_2_LocationDetails"
                    label={t('Delivery_Stop_2')}
                    placeholder={t('Enter_Drop_location') + ' 2'}
                    leftIconName="line-md:map-marker-radius-filled"
                    leftIconColor="primary.main"
                    onPlaceSelect={(place, type, name) => {
                      selectPlace(place, type, name);
                    }}
                    onSaveLocation={(place) => handleOnSaveLocation(place, 'delivery')}
                    onSavedLocationDelete={handleDeleteSavedLocation}
                    setGoogleMapsLinkData={setGoogleMapsLinkData}
                    setIsAddressPasted={setIsAddressPasted}
                    isAddressPasted={isAddressPasted}
                    isDisableForm={isDisableForm}
                  />
                  <IconButton
                    onClick={handleToggleSecondLocation}
                    disabled={isDisableForm}
                    aria-label="remove second delivery location"
                  >
                    <Iconify icon="line-md:close-circle-filled" sx={{ color: 'error.main' }} />
                  </IconButton>
                </Box>
              </Box>
            )}

            <Box display="flex" sx={{ gap: 1, flex: 1 }}>
              <Box display="flex" flexDirection="column" gap={1} flex={1}>
                <Field.Select
                  name="truckSize"
                  label={t('Truck_Size')}
                  placeholder={t('Truck_Size')}
                  options={fleets?.success || []}
                  isImage
                  labelKey={getLabelForlanguage('name')}
                  onChange={() => {
                    setValue('trucktype', '');
                    setValue('timeAndSlot', '');
                    setValue('loadType', '');
                    setValue('loadQauntity', '');
                    setValue('loadTypeText', '');
                  }}
                  imageKey="imagePaths.logo"
                />
              </Box>

              <Box display="flex" flexDirection="column" gap={1} flex={1}>
                <Field.Select
                  name="trucktype"
                  label={t('Truck_Type')}
                  placeholder={t('Truck_Type')}
                  labelKey={getLabelForlanguage('name')}
                  isImage
                  imageKey="imagePaths.logo"
                  options={getTruckType(fleets?.success, watch('truckSize'))}
                  noOptionsText={t('Please_select_truck_size')}
                  // extraWideOptions
                  renderOption={(renderProps, option) => (
                    <Box
                      component="li"
                      {...renderProps}
                      key={option.id}
                      display="flex"
                      alignItems="center"
                    >
                      <Avatar
                        src={option?.imagePaths?.logo}
                        sx={{ width: 45, height: 45, mr: 1 }}
                        slotProps={{ img: { style: { objectFit: 'contain' } } }}
                      />
                      <Box>
                        <Typography variant="button">
                          {option[getLabelForlanguage('name')]}{' '}
                          <Typography variant="caption">({option?.maximumLoad?.trim()})</Typography>
                        </Typography>
                        <Typography variant="caption" sx={{ display: 'block' }}>
                          Size {option.size}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  onChange={() => {
                    setValue('loadType', '');
                    setValue('loadQauntity', '');
                    setValue('loadTypeText', '');
                  }}
                />
              </Box>
            </Box>
          </Box>

          {watch('trucktype') &&
            watch('truckSize') &&
            watch('pickupLocation_search') &&
            watch('deliveryLocation_1_search') &&
            (!watch('isSecondDropLocationVisible') || watch('deliveryLocation_2_search')) && (
              <Box
                display="flex"
                sx={{
                  flexDirection: { xs: 'column', lg: 'row' },
                  flexWrap: 'wrap',
                  gap: 1,
                  flex: 1,
                }}
              >
                <Box display="flex" flexDirection="column" gap={1} flex={1}>
                  <Field.Slot
                    name="timeAndSlot"
                    slotsList={slots?.success}
                    label={t('Select_Date_Time')}
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} flex={1}>
                  <Field.Select
                    name="loadType"
                    options={getLoadType(
                      getTruckType(fleets?.success, watch('truckSize')),
                      watch('trucktype')
                    )}
                    label={t('Load_Type')}
                    placeholder={t('Select_LoadType')}
                    labelKey={getNameForLanguage('name')}
                    noOptionsText={t('Please_Select_Truck_Type')}
                  />
                </Box>

                {watch('loadType')?.label === 'others' && (
                  <Box display="flex" flexDirection="column" gap={1} flex={1}>
                    <Field.Text
                      name="loadTypeText"
                      placeholder={t('Enter_Load_Type')}
                      label={t('Enter_Load_Type')}
                    />
                  </Box>
                )}
                {watch('loadType')?.packetPrice > 0 && (
                  <Box display="flex" flexDirection="column" gap={1} flex={1}>
                    <Field.Text
                      name="loadQauntity"
                      label={t('Load_Quantity')}
                      placeholder={t('Enter_Load_Quantity')}
                      labelKey="nameen"
                    />
                  </Box>
                )}

                <Box display="flex" flexDirection="column" gap={1} flex={1}>
                  <Field.Text
                    name="goodsValue"
                    label={t('value_of_your_product')}
                    placeholder={t('Enter_the_value_of_your_product')}
                  />
                </Box>

                <Box display="flex" flexDirection="row" gap={1} alignItems="center">
                  <Counter
                    disabled={isDisableForm}
                    onChange={(val) => {
                      setValue('quantity', val);
                    }}
                  />
                </Box>
              </Box>
            )}

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            type="submit"
            loading={isPriceOfOrderLoading}
            sx={{
              height: 56,
              fontSize: 16,
              alignSelf: 'center',
              maxWidth: { md: 200, sm: 300, xs: '100%' },
            }}
          >
            {t('Get_Price')}
          </Button>
        </Box>
      </Form>

      {isInvoiceDetailsVisible && (
        <CustomDrawer
          open={isInvoiceDetailsVisible}
          handleback={handleInvoiceDetailsClose}
          title={t('Invoice_details')}
          onClose={handleInvoiceDetailsClose}
          width={500}
          zeroPadding={true}
        >
          <TableContainer
            sx={{ overflowX: 'unset', borderBottom: '1px dashed', borderColor: '#D3D3D3', mb: 2 }}
          >
            <Table>
              <TableHead sx={{ borderBottom: '1px dashed', borderColor: '#D3D3D3' }}>
                <TableRow sx={{ marginTop: -20 }}>
                  <TableCell sx={{ backgroundColor: 'transparent' }}>{t('Description')}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'transparent' }}>
                    {t('Price')}
                  </TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'transparent' }}>
                    {t('Qty')}
                  </TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'transparent' }}>
                    {t('Sub_Total')}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      display: !row?.visible && 'none',
                    }}
                  >
                    <TableCell sx={{ borderBottom: 'none' }}>{row.description}</TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                      {fCurrencyWithoutCode(row?.price)}
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                      {fCurrencyWithoutCode(row?.qty, 0)}
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                      {fCurrencyWithoutCode(row?.subtotal)}
                    </TableCell>
                  </TableRow>
                ))}
                {invoice?.labourPrice > 0 && (
                  <TableRow key="tet">
                    <TableCell sx={{ borderBottom: 'none' }}> {t('worker')}</TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none' }} />
                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                      {fCurrencyWithoutCode(invoice?.trucksCount * invoice?.loadQuanitity, 0)}
                    </TableCell>
                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                      {fCurrencyWithoutCode(invoice?.labourPrice)}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="h6" fontWeight="bold" color="primary.main">
              {t('Total')} {fCurrency(invoice?.totalPrice)}
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Button
              onClick={togglePaymentDrawer}
              variant="contained"
              color="primary"
              size="large"
              style={{ alignSelf: 'center' }}
              // fullWidth
              sx={{ mt: 2, width: '50%' }}
            >
              {t('Continue')}
            </Button>
          </Box>
        </CustomDrawer>
      )}

      {isUpdateContactDetailsModalVisible && (
        <UpdateContactDetailsModal
          open={isUpdateContactDetailsModalVisible}
          orderId={orderSuccessDetails?.orderID}
          handleClose={handleCloseContactDetailsModal}
          successMessage={orderSuccessDetails?.success}
          setIsUpdateContactDetailsModalVisible={setIsUpdateContactDetailsModalVisible}
          setShowBookNowForm={setShowBookNowForm}
        />
      )}

      {isPaymentDrawerVisible && (
        <PaymentDrawer
          open={isPaymentDrawerVisible}
          onClose={closePaymentDrawer}
          amount={invoice?.totalPrice}
          visibleView={visibleView}
          setVisibleView={setVisibleView}
          onPad={onPad}
          // STC PAYMENT URLS
          onStcInit={onStcInit}
          onStcVerify={onStcVerify}
          // Wallet Payment
          onWalletPayment={onWalletPayment}
          // card Payment handler
          onCardPayment={onCardPayment}
          onCreditPayment={onCreditPayment}
          isCombinationEnabled
        />
      )}

      {googleMapsLinkData?.modal && (
        <GoogleAddressPasteModal
          open={googleMapsLinkData?.modal}
          onClose={handleCloseGoogleAddressPasteModal}
          onPlaceSelect={(key, place) => {
            updateMapsData(key, place?.geometry?.location);
            setValue(googleMapsLinkData?.locationName, place);
          }}
          inputType={googleMapsLinkData?.locationType}
          setGoogleMapsLinkData={setGoogleMapsLinkData}
          setIsAddressPasted={setIsAddressPasted}
        />
      )}

      {isLoginModalVisible && (
        <CustomDrawer
          open={isLoginModalVisible}
          onClose={handleLoginBack}
          title={t('Login')}
          children={<Login submitLogin={login} loading={isLoginLoading} />}
          handleback={handleLoginBack}
        />
      )}

      {isLoginOTPModalVisible && (
        <CustomDrawer
          open={isLoginOTPModalVisible}
          onClose={handleLoginOTPBack}
          title={t('Login')}
          handleback={handleLoginOTPBack}
          children={
            <LoginOTP
              open={isLoginOTPModalVisible}
              submitLoginOTP={validateOTP}
              loading={isValidateOTPLoading}
              mobileNumber={loginData?.success?.mobileNumber}
            />
          }
        />
      )}

      {isRegisterModalVisible && (
        <CustomDrawer
          open={isRegisterModalVisible}
          onClose={handleRegisterBack}
          title={t('Register')}
          handleback={handleRegisterBack}
          children={
            <RegisterView
              open={isRegisterModalVisible}
              loading={isValidateOTPLoading}
              registerUser={registerUser}
              registerCompany={registerCompany}
              isUserRegisterLoading={isUserRegisterLoading}
              isCompanyRegisterLoading={isCompanyRegisterLoading}
            />
          }
        />
      )}
    </Box>
  );
}
